import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
import { X, ArrowRight } from "lucide-react";

export default function WorkModal({ item, onClose }) {
  return (
    <AnimatePresence>
      {item && (
        <motion.div
          data-testid="work-modal"
          className="fixed inset-0 z-[90] flex items-center justify-center p-4 sm:p-8"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <div className="absolute inset-0 bg-[#07080C]/90 backdrop-blur-md" onClick={onClose} data-testid="work-modal-backdrop" />
          <motion.div
            initial={{ opacity: 0, y: 40, scale: 0.97 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 24, scale: 0.98 }}
            transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
            className="chamfer-sm relative w-full max-w-4xl bg-gradient-to-br from-[#2A3045] to-[#1E2335] p-px"
          >
            <div className="chamfer-sm max-h-[85vh] overflow-y-auto bg-[#0D0E15]">
              <div className="relative">
                <img src={item.image} alt={`${item.title} full concept preview`} className="aspect-[16/9] w-full object-cover" />
                <button
                  data-testid="work-modal-close-button"
                  onClick={onClose}
                  aria-label="Close project details"
                  className="absolute top-4 right-4 flex h-10 w-10 items-center justify-center border border-[#1E2335] bg-[#07080C]/80 text-slate-300 backdrop-blur transition-colors duration-200 hover:border-cyan-400/60 hover:text-cyan-300"
                >
                  <X className="h-4 w-4" />
                </button>
              </div>
              <div className="p-6 sm:p-10">
                <span className="mono-label">{item.category} — {item.year}</span>
                <h3 className="font-display mt-3 text-3xl font-extrabold tracking-tight text-slate-50 sm:text-4xl">{item.title}</h3>
                <p className="mt-4 max-w-2xl text-base leading-relaxed text-slate-400">{item.description}</p>
                <div className="mt-8 grid gap-px border border-[#1E2335] bg-[#1E2335] sm:grid-cols-2">
                  <div className="bg-[#0D0E15] p-5">
                    <span className="mono-label text-slate-500">Outcome</span>
                    <p className="font-display mt-2 text-xl font-bold text-cyan-300">{item.metric}</p>
                  </div>
                  <div className="bg-[#0D0E15] p-5">
                    <span className="mono-label text-slate-500">Delivered</span>
                    <p className="mt-2 text-sm text-slate-300">{item.stack.join(" · ")}</p>
                  </div>
                </div>
                <div className="mt-8 flex justify-end">
                  <Link
                    to={`/work/${item.id}`}
                    data-testid="work-modal-case-study-link"
                    onClick={onClose}
                    className="group inline-flex items-center gap-2 border border-cyan-400/40 bg-cyan-400/10 px-5 py-3 font-mono text-[11px] font-bold tracking-[0.2em] text-cyan-300 uppercase transition-all duration-200 hover:bg-cyan-400 hover:text-[#07080C]"
                  >
                    Full Case Study
                    <ArrowRight className="h-3.5 w-3.5 transition-transform duration-200 group-hover:translate-x-1" />
                  </Link>
                </div>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
